import { render, staticRenderFns } from "./ProcessDashboard.vue?vue&type=template&id=10b43aac&scoped=true"
import script from "./ProcessDashboard.vue?vue&type=script&lang=js"
export * from "./ProcessDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProcessDashboard.vue?vue&type=style&index=0&id=10b43aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b43aac",
  null
  
)

export default component.exports